import { getGlobalSubscriptionState } from '../../analytics/shared';
import { GALLERY_SELECTOR, GALLERY_SELECTOR_WRAPPER } from '../../classnames/above-the-fold-gallery';

const SUBSCRIPTION_GALLERY_IMAGES_CONTAINER = '#subscription-gallery-images-container';

export default class SubscriptionGalleryHandler {
  constructor(containers) {
    this.containers = containers;
  }

  // Stores the current gallery image nodes.
  galleryOriginalImageElements = {};
  galleryThumbnailImageElements = {};

  // Subscription/otp gallery image URLs collection.
  otpProductMainImageUrls = {};
  subscriptionMainImageUrls = {};

  swapImageUrls = (nodeList, urlsCollection, urlKey) => {
    Object.entries(nodeList).forEach(([variantId, img]) => {
      const URL = urlsCollection?.[variantId]?.[urlKey];

      if (!URL) return;

      img.src = URL;
      img.dataset.src = URL;
      img.dataset.originalImage = URL;
    });
  };

  handle = ({ subscription }) => {
    this.containers.forEach((container) => {
      container.querySelectorAll(GALLERY_SELECTOR).forEach((product) => {
        this.galleryOriginalImageElements[product.dataset.productId] = product.querySelector('.image__wrapper img');
        this.galleryThumbnailImageElements[product.dataset.productId] =
          product.querySelector(`.${GALLERY_SELECTOR_WRAPPER} img`);
      });
    });

    if (subscription === 'subscription') {
      this.swapImageUrls(this.galleryOriginalImageElements, this.subscriptionMainImageUrls, 'originalImageUrl');
      this.swapImageUrls(this.galleryThumbnailImageElements, this.subscriptionMainImageUrls, 'thumbnailImageUrl');
    } else {
      this.swapImageUrls(this.galleryOriginalImageElements, this.otpProductMainImageUrls, 'originalImageUrl');
      this.swapImageUrls(this.galleryThumbnailImageElements, this.otpProductMainImageUrls, 'thumbnailImageUrl');
    }
  };

  initializeEventListeners = () => {
    // Get all the subscription/otp gallery images and store them in a collection.
    this.containers.forEach((container) => {
      const subscriptionGalleryContainerLength = container
        .querySelectorAll(SUBSCRIPTION_GALLERY_IMAGES_CONTAINER).length;

      if (!subscriptionGalleryContainerLength) {
        return;
      }

      container.querySelectorAll(GALLERY_SELECTOR).forEach((product) => {
        const { originalImage, src } = product.querySelector('.image__wrapper img').dataset;

        this.otpProductMainImageUrls[product.dataset.productId] = {
          originalImageUrl: originalImage || src,
          thumbnailImageUrl: src
        };
      });

      container.querySelectorAll(`${SUBSCRIPTION_GALLERY_IMAGES_CONTAINER} .subscription-image`)
        .forEach((product) => {
          const { originalImage, src } = product.querySelector('.image__wrapper img').dataset;

          this.subscriptionMainImageUrls[product.dataset.productId] = {
            originalImageUrl: originalImage,
            thumbnailImageUrl: src
          };
        });
    });

    // Initialize the subscription gallery handler with the current subscription value on page load.
    this.handle({ subscription: getGlobalSubscriptionState() });

    window.currentVariantStorage.subscribe(this);
  };
}
